import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  MdDashboard,
  MdUpload,
  MdPeople,
  MdGroups,
  MdEmojiEmotions,
  MdImage,
  MdVideoLibrary,
  MdCreditCard,
  MdCelebration,
  MdSettings,
  MdCropFree
} from 'react-icons/md';
import { clearAuthToken, getRemainingTime } from '../utils/auth';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthToken();
    navigate('/admin/login');
  };

  // Auto logout when expired - check every minute
  useEffect(() => {
    const checkExpiration = () => {
      const remaining = getRemainingTime();

      // Auto logout when expired
      if (remaining <= 0) {

        handleLogout();
      }
    };

    // Check immediately
    checkExpiration();

    // Check every minute
    const interval = setInterval(checkExpiration, 60000);

    return () => clearInterval(interval);
  }, [handleLogout]);

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: MdDashboard },
    { path: '/admin/uploads', label: 'Uploads', icon: MdUpload },
    { path: '/admin/users', label: 'Users Management', icon: MdPeople },
    { path: '/admin/leaders', label: 'My Leaders', icon: MdGroups },
    { path: '/admin/stickers', label: 'Stickers', icon: MdEmojiEmotions },
    { path: '/admin/banners', label: 'Banners', icon: MdImage },
    { path: '/admin/default-frames', label: 'Default Frames', icon: MdCropFree },
    { path: '/admin/help-videos', label: 'Help Videos', icon: MdVideoLibrary },
    { path: '/admin/birthdays', label: 'Birthdays', icon: MdCelebration },
    { path: '/admin/partners', label: 'Partners', icon: MdGroups },
    { path: '/admin/subscriptions', label: 'Subscriptions', icon: MdCreditCard },
    { path: '/admin/settings', label: 'Settings', icon: MdSettings }
  ];

  return (
    <div className="admin-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <img src="/Logo.jpeg" alt="Admin Logo" className="logo-icon" />
            <span className="logo-text">Admin Dashboard</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <item.icon className="nav-icon" />
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>
      <main className="main-content">
        <header className="top-header">
          <h1>Welcome to Admin Dashboard</h1>
          <div className="user-info">
            <span>Admin User</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </header>
        <div className={`content ${location.pathname === '/admin/dashboard' ? 'dashboard-content' : ''}`}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
